<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="btn-type1">
        <el-button size="mini" type="primary" icon="el-icon-search" @click="goOpen">
          {{ this.$i18n.messages[this.$store.state.locale].search }}
        </el-button>
      </div>
      <div class="pop-content-search">
        <el-form size="mini" label-width="65px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="제조사">
                <el-select v-model="maker">
                  <el-option
                      v-for="item in makerList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="제품군">
                <el-select v-model="modelGroup" @change="onModelGroupChange">
                  <el-option
                      v-for="item in modelGroupList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.key">
                  </el-option>
                </el-select>
                <el-select  v-model="subModelGroup">
                  <el-option
                      v-for="item in subModelGroupList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="대표모델" label-width="80px">
                <el-input type="text" v-model="standardModelNm"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="모델">
                <el-input type="text" v-model="modelNm"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="table-area">
        <div class="table-b">
          <ag-grid-vue
              style="width: 100%; height: 320px;"
              class="ag-theme-alpine"
              row-selection="single"

              :column-defs="columnDefs"
              :grid-options="gridOptions"
              :row-data="rowData"
              :default-col-def="defaultColDef"
              @rowDoubleClicked="rowDoubleClick"
              @grid-ready="onGridReady"
              @cell-clicked="onCellClicked" />
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
  props: {
    tabData: {
      Type: Array
      , required: false
    },
    custNo: {
      Type: String
      , required: false
    }
  },
  components: {Layout, AgGridVue},
  data() {
    return {
      title: '모델선택',

      // AG-GRID OPTION [START]
      rowData:[],
      gridOptions: {},

      maker: '', /** 제조사 */
      makerList: [], /** 제조사 리스트*/
      modelGroup: '', /** 제품군 */
      modelGroupList: [], /** 제품군 리스트*/
      modelGroupNmList: [], /** 제품군 명칭 리스트*/
      subModelGroup: '', /** 제품군 */
      subModelGroupList: [], /** 제품군 리스트*/
      subModelGroupShow: false,
      standardModelNm: '', /** 대표모델 */
      modelNm: '', /** 모델 */

      columnDefs:[
        {
          headerName: '제조사',
          width:200,
          field:'makerNm',
          cellStyle:{textAlign:'center'}
        },
        {
          headerName: '제품군',
          width:200,
          field:'modelGroupNm',
          cellStyle:{textAlign:'center'}
        },
        {
          headerName: '대표모델',
          width:200,
          field:'standardModelNm',
          cellStyle:{textAlign:'center'}
        },
        {
          headerName: '모델',
          width:400,
          field:'modelNm',
          cellStyle:{textAlign:'center'}
        },
      ],
      defaultColDef: {
        resizable: true,
        filter:true,
        sortable: true
      },
      form: {
        custId: '0',
        siteId: '0'
      }
    }
  },
  mounted() {
    // this.form = this.tabData[0] ? this.tabData[0].param : {}

  },
  methods: {
    closeModal() {
      this.$parent.close();
    },
    onGridReady(){
      this.getCombo({flag: 'INIT'})
    },
    rowDoubleClick(params){
      this.$emit('close', params.data);
    },
    onCellClicked(event) {
      console.log('add onCellClicked  start===', event)
      this.$emit('close', event);
      this.closeModal();
    },
    getCombo(param) {
      if(param.flag === 'INIT'){
        // 제조사
        this.$http.get(`/api/codeMng/combo`, {params: {parentId: 196}})
            .then(response => {
              this.makerList = response.data || []
              this.makerList.unshift({key:'', value:'전체'})
            });

        // 제품군 : ModelGroup, CAT_LVL(2)
        this.$http.get(`/api/codeMng/combo`, {params: {parentId: 143}})
            .then(response => {
              this.modelGroupNmList = response.data || []
              this.modelGroupNmList.unshift({key:'', value:'전체'})
            });
        // 제품군 : ModelGroup, CAT_LVL(2)
        this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 143}})
            .then(response => {
              this.modelGroupList = response.data || []
              this.modelGroupList.unshift({key:'', value:'전체'})
              console.log('response.data :', response.data )
            });
      } else {
        if(param.parentId === ''){
          this.subModelGroupShow =  false
        } else{
          this.subModelGroupShow =  true

          // 하위 제품군 : ModelGroup, CAT_LVL(2)
          this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
              .then(response => {
                this.subModelGroupList = response.data || []
                this.subModelGroupList.unshift({key:'', value:'전체'})
                this.subModelGroup = ''
              });
        }

      }
    },
    onModelGroupChange(e){
      console.log('onModelGroupChange start====', e.target)
      // 모델이 변경시 하위 제품군 조회
      this.getCombo({flag: '', parentId: e})
    },
    goOpen(){
      this.$store.commit('loading')
      const vModelIdx = this.modelGroupList.findIndex(x=>x.key === this.modelGroup)
      const vModelGroupCatKey = this.modelGroupNmList[vModelIdx].key || ''

      const vform = {
        companyId: this.$store.state.loginInfo.compCd || '',
        custId:  '0',
        siteId:  '0',
        modelCd: '',
        maker: this.maker || '',
        modelGroup: (this.subModelGroup ? this.subModelGroup : vModelGroupCatKey) || '',
        standardModelNm: this.standardModelNm || '',
        modelNm: this.modelNm || '',
        sortType: '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime: ''
      }
      // console.log('add goOpen start', vform)
      this.$http.post(("/api/asMng/popup/siteModelSelect/searchModelAddList"), vform
      ).then(response => {
        console.log('addmodal response.data' , response.data)
        if(response.data.callModelSelPageList){
          this.rowData = response.data.callModelSelPageList || []
        }

      }).finally(() => {
        this.$store.commit('finish')

      });
    }
  }
}
</script>

<style lang="scss" scoped>
// .modal-card {
//   width: 970px;
// }

// .display-area {
//   :global(img) {
//     width: 100%;
//   }
// }
</style>